import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";
import JoditEditor from "jodit-react";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState();
  const [imagePreview1, setImagePreview1] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);
  const [errorMesage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    image1: null,
    image2: null,
  });
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (e.target.type === "file") {
      const selectedImage = e.target.files[0];

      // Check if a file is selected
      if (selectedImage) {
        // Generate image preview and update formData based on the input name
        const reader = new FileReader();
        reader.onloadend = () => {
          if (e.target.name === "image1") {
            setImagePreview1(reader.result);
            setFormData({ ...formData, image1: selectedImage });
          } else if (e.target.name === "image2") {
            setImagePreview2(reader.result);
            setFormData({ ...formData, image2: selectedImage });
          }
        };
        reader.readAsDataURL(selectedImage);
      } else {
        // User canceled image selection, clear the image preview and formData
        if (e.target.name === "image1") {
          setImagePreview1(null);
          setFormData({ ...formData, image1: null });
        } else if (e.target.name === "image2") {
          setImagePreview2(null);
          setFormData({ ...formData, image2: null });
        }
      }
    } else {
      // Handle text input
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleDescriptionChange = (value) => {
    setFormData({ ...formData, description: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("image1", formData.image1);
        formDataToSend.append("image2", formData.image2);

        const response = await postData("/masters/blogs", formDataToSend);
        if (response.success) {
          setErrorMessage("");
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else if (response?.code == 400) {
          setErrorMessage(response?.message);
        } else {
          setErrorMessage("");
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
        await setErrors();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const validateForm = () => {
    let errors = {};
    const regexAlfaNumric = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
    const regexAlfa = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

    if (!formData.name) {
      errors.name = "Name is required";
    }

    if (!formData.image1) {
      errors.image1 = "Image is required";
    }
    if (!formData.image2) {
      errors.image2 = "Image is required";
    }

    if (!formData.description) {
      errors.description = "description is required";
    }

    return errors;
  };
  const errorStyle = {
    color: "red",
    marginLeft: "5px",
    // fontSize: "11px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add Solution</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add blog</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="blogclass"
                          >
                            <Row>
                              <Col
                                lg={9}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-2">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={2}>
                                          Name
                                        </Form.Label>
                                        <Col sm={9}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Name "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {errors?.name && (
                                              <span style={errorStyle}>
                                                {errors?.name}
                                              </span>
                                            )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-2">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={2}>
                                          Outer Image
                                        </Form.Label>

                                        <Col sm={9}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="file"
                                                name="image1"
                                                accept="image/*"
                                                onChange={handleChange}
                                              />
                                            </InputGroup>
                                            {errors?.image1 && (
                                              <span style={errorStyle}>
                                                {errors?.image1}
                                              </span>
                                            )}
                                          </Form.Group>

                                          <Row>
                                            {imagePreview1 ? (
                                              <img
                                                src={imagePreview1}
                                                alt="Image Preview"
                                                className="table-image"
                                                style={{
                                                  height: "100px",
                                                  width: "100px",
                                                  marginLeft: "120px",
                                                  margin: "2px",
                                                  backgroundSize: "fixed",
                                                }}
                                              />
                                            ) : (
                                              <p style={{ marginLeft: "10px" }}>
                                                No image selected
                                              </p>
                                            )}
                                          </Row>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-2">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={2}>
                                          Inner Image
                                        </Form.Label>

                                        <Col sm={9}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="file"
                                                name="image2"
                                                accept="image/*"
                                                onChange={handleChange}
                                              />
                                            </InputGroup>
                                            {errors?.image2 && (
                                              <span style={errorStyle}>
                                                {errors?.image2}
                                              </span>
                                            )}
                                            {errorMesage.length >= 1 && (
                                              <span style={errorStyle}>
                                                {errorMesage}
                                              </span>
                                            )}
                                          </Form.Group>

                                          <Row>
                                            {imagePreview2 ? (
                                              <img
                                                src={imagePreview2}
                                                alt="Image Preview"
                                                className="table-image"
                                                style={{
                                                  height: "100px",
                                                  width: "100px",
                                                  marginLeft: "120px",
                                                  margin: "2px",
                                                  backgroundSize: "fixed",
                                                }}
                                              />
                                            ) : (
                                              <p style={{ marginLeft: "10px" }}>
                                                No image selected
                                              </p>
                                            )}
                                          </Row>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-2">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={2}>
                                          Description
                                        </Form.Label>
                                        <Col sm={9}>
                                          <Form.Group>
                                            <InputGroup>
                                              <JoditEditor
                                                ref={editor}
                                                value={formData.description}
                                                tabIndex={2}
                                                className="custom-jodit-editor"
                                                onBlur={(newContent) =>
                                                  setContent(newContent)
                                                }
                                                onChange={
                                                  handleDescriptionChange
                                                }
                                              />
                                            </InputGroup>
                                            {errors?.description && (
                                              <span style={errorStyle}>
                                                {errors?.description}
                                              </span>
                                            )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
